
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){

        this.resizeInit = false
        // this.defaultQueryList = {
        //     mobile: matchMedia("(max-width: 991px"),
        //     pc: matchMedia("(min-width: 992px)")
        // }
        
        barba.hooks.afterOnce((data) => {
            this.init()
        })
       
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        const hero = document.querySelector(".l-hero")
        if(hero){
            
            this.windowWidth = window.innerWidth
            this.elem = document.querySelector("#hero-video");

            this.sourceList = this.elem.querySelectorAll("[data-src]");
            this.routingByBreakpoint()

            if(!this.resizeInit){
                window.addEventListener('resize',()=>{
                    this.resize()
                    if(!this.resizeInit){
                        this.resizeInit = true
                    }
                })
            }
        }
    }
    resize(){
        if(window.innerWidth != this.windowWidth){
            if(window.innerWidth > 992 && this.windowWidth < 992){
                this.routingByBreakpoint()
                this.windowWidth = window.innerWidth
            }else if(window.innerWidth < 991 && this.windowWidth > 991){
                this.routingByBreakpoint()
                this.windowWidth = window.innerWidth
            }
        }
    }
    routingByBreakpoint() {
        // for(let i = 0, l = this.sourceList.length; i < l; i++){
        //     const source = this.sourceList[i];
            // if(!(source.dataset.query && this.defaultQueryList[source.dataset.query] && source.dataset.src)) continue;
            if(window.innerWidth < 992){
                const source = this.elem.querySelector("[data-query='mobile']");
                const newSource = this.elem.querySelector("[data-source]");
                newSource.src = source.dataset.src;
                this.elem.load()
            }else if(window.innerWidth > 991){
                const source = this.elem.querySelector("[data-query='pc']");
                const newSource = this.elem.querySelector("[data-source]");
                newSource.src = source.dataset.src;
                this.elem.load()
            }
    
        // }
    }
}